// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pmprofilepg-inline-1 {
  font-size: 13px;
  font-weight: 600;
}

.pmprofilepg-inline-2 {
  margin-top: 16px;
}

.pmprofilepg-inline-3 {
  font-size: 13px;
  font-weight: 600;
}

.pmprofilepg-inline-4 {
  margin-top: 16px;
}

.pmprofilepg-inline-5 {
  font-size: 13px;
  font-weight: 600;
}

.pmprofilepg-dyn-1 {
  text-align: center;
  padding: 40px;
  color: var(--pmprofilepg-1-color);
}

.pmprofilepg-dyn-2 {
  font-size: 12px;
  color: var(--pmprofilepg-2-color);
  min-width: 120px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/PM/PMProfilePg.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB","sourcesContent":[".pmprofilepg-inline-1 {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.pmprofilepg-inline-2 {\n  margin-top: 16px;\n}\n\n.pmprofilepg-inline-3 {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.pmprofilepg-inline-4 {\n  margin-top: 16px;\n}\n\n.pmprofilepg-inline-5 {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.pmprofilepg-dyn-1 {\n  text-align: center;\n  padding: 40px;\n  color: var(--pmprofilepg-1-color);\n}\n\n.pmprofilepg-dyn-2 {\n  font-size: 12px;\n  color: var(--pmprofilepg-2-color);\n  min-width: 120px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
